import React from 'react'
import { View, ViewStyle } from 'react-native'
import { createStyle } from '../../../contexts/global-styles.provider'

interface ShadowContainerProps {
  children: React.ReactNode
  shadowType?: 'top' | 'bottom' | 'both' | 'none'
  style?: ViewStyle
}

/**
 * https://www.notion.so/coderbunker/shadow-container-29c0892b6c3080198b0cfe5187518d65?source=copy_link
 */
export const ShadowContainer = ({
  children,
  shadowType = 'bottom',
  style,
}: ShadowContainerProps) => {
  const styles = useStyle()

  const shadowStyleMap = {
    top: styles.topShadow,
    bottom: styles.bottomShadow,
    both: styles.bothShadow,
    none: styles.noShadow,
  }

  const getShadowStyle = () => shadowStyleMap[shadowType] || styles.bottomShadow

  return (
    <View style={[styles.container, getShadowStyle(), style]}>{children}</View>
  )
}

const useStyle = createStyle(({ theme }) => {
  // Shadow constants for consistency
  const shadowColor = '#000'
  const shadowOpacity = 0.2
  const shadowRadius = 6
  const elevation = 8
  const shadowMargin = 8

  return {
    container: {
      backgroundColor: 'white',
      padding: 10,
    },
    topShadow: {
      shadowColor,
      shadowOffset: {
        width: 0,
        height: -4,
      },
      shadowOpacity,
      shadowRadius,
      elevation,
      marginTop: shadowMargin, // Add space for top shadow to be visible
    },
    bottomShadow: {
      shadowColor,
      shadowOffset: {
        width: 0,
        height: 4,
      },
      shadowOpacity,
      shadowRadius,
      elevation,
      marginBottom: shadowMargin, // Add space for bottom shadow to be visible
    },
    bothShadow: {
      shadowColor,
      shadowOffset: {
        width: 0,
        height: 0,
      },
      shadowOpacity,
      shadowRadius,
      elevation,
      marginTop: shadowMargin, // Add space for top shadow to be visible
      marginBottom: shadowMargin, // Add space for bottom shadow to be visible
    },
    noShadow: {
      shadowColor: 'transparent',
      shadowOffset: {
        width: 0,
        height: 0,
      },
      shadowOpacity: 0,
      shadowRadius: 0,
      elevation: 0,
    },
  }
})
